import { useProcessingBackgroundVideoPlayback } from 'modules/coaching/components/useProcessingBackgroundVideoPlayback'
import styles from 'modules/coaching/components/VideoAgentScreen.module.css'

type ProcessingBackgroundVideoProperties = {
  isPaused: boolean
  sources: string[]
}

/**
 * Blurred processing backdrop that cycles across all uploaded videos in 5-second clips.
 * Order: video1[0-5], video2[0-5], … then video1[5-10], video2[5-10], …
 */
export const ProcessingBackgroundVideo = ({ isPaused, sources }: ProcessingBackgroundVideoProperties) => {
  /* --- Section 1: Hooks --- */
  const { activeSource, videoReference } = useProcessingBackgroundVideoPlayback({ isPaused, sources })

  /* --- Section 5: Early Returns --- */
  if (!activeSource) {
    return <div className={styles.videoAgentProcessingAmbient} aria-hidden />
  }

  /* --- Section 6: Render --- */
  return (
    <video
      ref={videoReference}
      className={styles.videoAgentProcessingVideo}
      src={activeSource}
      muted
      playsInline
      preload="metadata"
      aria-hidden
    />
  )
}
